import { doLogout } from "actions/authAction";
import {
  BASE_URL,
  MAINTENANCE_MODAL,
  MAINTENANCE_GET_SUCCESS,
  ADD_MAINTENANCE_GET_SUCCESS,
  DELETE_MAINTENANCE_GET_SUCCESS,
  EDIT_MAINTENANCE_GET_SUCCESS,
  MAINTENANCE_MODAL_PAGE,
} from "./constant";

const editMaintenancesuccess = (bool, data) => {
  return {
    type: EDIT_MAINTENANCE_GET_SUCCESS,
    load: bool,
    val: data,
  };
};

const DeleteMaintenancesuccess = (bool, data) => {
  return {
    type: DELETE_MAINTENANCE_GET_SUCCESS,
    load: bool,
    val: data,
  };
};

const addMaintenancesuccess = (bool, data) => {
  return {
    type: ADD_MAINTENANCE_GET_SUCCESS,
    load: bool,
    val: data,
  };
};

const maintenanceGetSuccess = (bool, kapal) => {
  return {
    type: MAINTENANCE_GET_SUCCESS,
    load: bool,
    val: kapal.data,
  };
};

export const Modal = (data) => async (dispatch) => {
  dispatch({
    type: MAINTENANCE_MODAL,
    val: data,
  });
};

export const maintenancePageState = (data) => async (dispatch) => {
  dispatch({
    type: MAINTENANCE_MODAL_PAGE,
    val: data,
  });
};

export const maintenanceFetchAll = () => {
  return (dispatch) => {
    dispatch(maintenanceGetSuccess(true, { data: [] }));
    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + "maintenance", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(maintenanceGetSuccess(false, data));
      })
      .catch((err) => {
        console.log(err);
        dispatch(maintenanceGetSuccess(false, { data: [] }));
      });
  };
};

export const DeleteMaintenance = (data) => {
  return (dispatch) => {
    dispatch(DeleteMaintenancesuccess(true, {}));
    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + `maintenance/${data}`, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          dispatch(maintenanceFetchAll());
        } else {
          window.alert(data.message);
        }
        dispatch(DeleteMaintenancesuccess(false, data));
      })
      .catch((err) => {
        console.log(err);
        dispatch(DeleteMaintenancesuccess(false, {}));
      });
  };
};

export const editMaintenance = (props) => {
  return (dispatch) => {
    const data = {
      tgl_jam_mulai: props.tgl_jam_mulai,
      tgl_jam_selesai: props.tgl_jam_selesai,
      keterangan: props.keterangan,
      status: props.status,
    };
    dispatch(editMaintenancesuccess(true, {}));
    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + `maintenance/${props.id}`, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          dispatch(maintenanceFetchAll());
        } else {
          window.alert(data.message);
        }
        dispatch(editMaintenancesuccess(false, data));
      })
      .catch((err) => {
        console.log(err);
        dispatch(editMaintenancesuccess(false, {}));
      });
  };
};

export const addMaintenance = (data) => {
  return (dispatch) => {
    dispatch(addMaintenancesuccess(true, {}));
    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + "maintenance", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          dispatch(maintenanceFetchAll());
        } else {
          window.alert(data.message);
        }
        dispatch(addMaintenancesuccess(false, data));
      })
      .catch((err) => {
        console.log(err);
        dispatch(addMaintenancesuccess(false, {}));
      });
  };
};
